// extracted by mini-css-extract-plugin
export default {"btnMenu":"email-jobs_btnMenu__Qjhig","addEmailJobBtn":"email-jobs_addEmailJobBtn__LJuGF"};